import { Link } from 'react-router-dom';

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-background text-text">
      <header className="sticky top-0 z-40 border-b border-black/5 bg-white/85 backdrop-blur">
        <div className="mx-auto flex max-w-5xl items-center justify-between px-6 py-4 lg:px-8">
          <Link to="/" className="flex items-center gap-3">
            <img src="/logo.png" alt="AuthWorka" className="h-10 w-auto" />
            <span className="text-lg font-black text-primary">AuthWorka</span>
          </Link>

          <div className="flex items-center gap-3">
            <Link
              to="/terms"
              className="text-sm font-medium text-muted transition hover:text-primary"
            >
              Terms & Conditions
            </Link>
            <Link
              to="/register"
              className="rounded-xl bg-primary px-4 py-2 text-sm font-semibold text-white"
            >
              Get started
            </Link>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-6 py-12 lg:px-8">
        <div className="rounded-[2rem] border border-black/5 bg-white p-8 shadow-sm sm:p-12">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-primary">
            Legal
          </p>
          <h1 className="mt-3 text-4xl font-black tracking-tight">Privacy Policy</h1>
          <p className="mt-4 text-sm text-muted">
            Effective date: {new Date().getFullYear()}
          </p>

          <div className="mt-10 space-y-8 text-sm leading-7 text-muted">
            <section>
              <h2 className="text-xl font-bold text-text">1. Overview</h2>
              <p className="mt-2">
                AuthWorka values your privacy. This Privacy Policy explains how we collect,
                use, store, and protect information you provide when using the platform.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-text">2. Information We Collect</h2>
              <p className="mt-2">
                We may collect account details, profile information, contact information,
                uploaded documents, activity records, support submissions, payment-related
                transaction references, and other data required to operate the platform.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-text">3. How We Use Information</h2>
              <p className="mt-2">
                We use information to create accounts, operate platform features, support
                hiring workflows, manage digital resources, improve security, handle moderation,
                and communicate relevant updates to users.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-text">4. Verification and Safety</h2>
              <p className="mt-2">
                Some information may be used for identity verification, guarantor handling,
                vetting workflows, dispute resolution, complaint review, payment verification,
                and administrative oversight where applicable.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-text">5. Data Sharing</h2>
              <p className="mt-2">
                We do not share your data except where needed to operate platform features,
                comply with legal obligations, maintain safety, process verified payments,
                or support workflows between relevant users on the platform.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-text">6. Learning Resources and Payments</h2>
              <p className="mt-2">
                When users purchase paid learning resources, we may store transaction
                references, payment status information, and related access records in order
                to verify payment and control access to protected content.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-text">7. Data Storage and Protection</h2>
              <p className="mt-2">
                We take reasonable steps to protect user data from unauthorized access,
                misuse, loss, or disclosure. No system can guarantee absolute security,
                but we aim to maintain responsible safeguards.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-text">8. User Responsibility</h2>
              <p className="mt-2">
                You are responsible for ensuring that information you provide is accurate and
                for protecting your login credentials and device access.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-text">9. Cookies and Similar Tools</h2>
              <p className="mt-2">
                AuthWorka may use essential browser storage or similar mechanisms to support
                authentication, platform preferences, and session continuity.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-text">10. Changes to This Policy</h2>
              <p className="mt-2">
                We may update this Privacy Policy from time to time. Continued use of the
                platform after changes means you accept the revised policy.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-text">11. Contact</h2>
              <p className="mt-2">
                If you have questions about this Privacy Policy, please contact the
                AuthWorka team through the platform support channels.
              </p>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
}